import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import Select from 'react-select';

import { getInvoiceDetails } from '../app/store/actions/invoice';
import {
  createInvoiceDevolutionSolicitation, deleteInvoiceDevolutionFile,
  getClientContactEmailsList, getSphereMotivosList,
  sendInvoiceDevolutionSolicitation, uploadInvoiceDevolutionFile,
} from '../app/store/actions/invoiceDevolution';
import ROUTES from '../data/routes';
import randomPassword from '../helpers/generator';
import { history } from '../routers/AppRouter';

const customSelectStyles = {
  control: base => ({
    ...base,
    textAlign: 'center',
    border: '1px solid black',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
  }),
  valueContainer: base => ({
    ...base,
    overflowY: 'auto !important',
    height: '90px',
  }),
};

class InvoiceDevolutionSolicitationPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.fileInput = React.createRef();
    this.state = this.cleantData();
  }

  componentDidMount = () => {
    setTimeout(async () => {
      await this.props.getSphereNCIMotivosList(this.state.devolutionReasonType);
      await this.props.getClientContactEmailsList(this.props.clientId);
    }, 0);
  }

  cleantData = () => ({
    devolutionReasonType: 'devolucao',
    invoiceDetails: [],
    invoiceNumber: '',
    invoiceDataReturned: false,
    invoiceError: false,
    invoiceErrorMessage: '',
    returnedProducts: {},
    reason: '',
    description: '',
    freight: '',
    devolutionType: '',
    hasDevolutionLetter: '',
    contactEmail: [],
    attachment: '',
    error: false,
    errorMessage: '',
    success: false,
    successMessage: '',
  })

  handleSubmit = async (event) => {
    event.preventDefault();

    const {
      invoiceNumber, returnedProducts,
      reason, description, freight,
      devolutionType, hasDevolutionLetter, contactEmail,
      attachment,
    } = this.state;

    if (!invoiceNumber) {
      await this.setState({
        error: true,
        errorMessage: I18n.t('mandatoryFillSalesInvoiceNumber'),
      });
    } else if (!Object.keys(returnedProducts).length) {
      await this.setState({
        error: true,
        errorMessage: I18n.t('productNeedToOpenReturnRequest'),
      });
    } else if (!reason) {
      await this.setState({
        error: true,
        errorMessage: I18n.t('mandatoryToFillReasonToOpenReturnRequest'),
      });
    } else if (!description) {
      await this.setState({
        error: true,
        errorMessage: I18n.t('mandatoryDescriptionToOpenReturnRequest'),
      });
    } else if (!freight) {
      await this.setState({
        error: true,
        errorMessage: I18n.t('mandatoryFreightTypeToOpenReturnRequest'),
      });
    } else if (!devolutionType) {
      await this.setState({
        error: true,
        errorMessage: I18n.t('mandatoryReturnTypeToOpenReturnRequest'),
      });
    } else if (!hasDevolutionLetter) {
      await this.setState({
        error: true,
        errorMessage: I18n.t('mandatoryReturnLetterToOpenReturnRequest'),
      });
    } else if (!contactEmail.length) {
      await this.setState({
        error: true,
        errorMessage: I18n.t('requiredSelectContactEmailsToOpenReturnRequest'),
      });
    } else {
      try {
        const { clientId } = this.props;

        let file = null;
        if (attachment) file = await this.uploadFile(attachment, clientId);

        const itens = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const productCode in returnedProducts) {
          if (Object.hasOwnProperty.call(returnedProducts, productCode)) {
            const quantity = returnedProducts[productCode].replace(',', '.');

            itens.push({
              it_codigo: productCode,
              quantidade: Number(quantity),
            });
          }
        }

        const data = {
          nota_fiscal: invoiceNumber,
          motivo: Number(reason),
          cod_cliente: String(clientId),
          frete: freight,
          tipo_devolucao: Number(devolutionType),
          carta_de_devolucao: hasDevolutionLetter,
          arquivo: file ? file.name : null,
          descricao: description,
          contatos_ids: contactEmail.join(';'),
          itens,
        };

        const result = await this.props.sendSolicitation(data);

        if (result && result.success) {
          await this.props.createSolicitation(data, result.response);

          await this.setState({
            success: true,
            successMessage: I18n.t('returnRequestOpenSuccessfully'),
            error: false,
            errorMessage: '',
          });
        } else {
          if (file) await deleteInvoiceDevolutionFile(file.name);

          await this.setState({
            error: true,
            errorMessage: (result && result.response) ? result.response : I18n.t('sphereRejectSolicitation'),
          });
        }
      } catch (err) {
        await this.setState({
          error: true,
          errorMessage: I18n.t('unknownErrorWhenOpeningReturnRequest'),
        });
      }
    }
  }

  uploadFile = async (file, clientId) => {
    try {
      const { opico } = this.props;
      const hash = randomPassword();
      const extension = file.name.split('.').pop();
      const name = `${opico}${hash}.${extension}`;
      const image = await this.props.uploadInvoiceDevolutionFile(file, name, clientId);

      return image;
    } catch (err) {
      await this.setState({
        error: true,
        errorMessage: I18n.t('unknownErrorWhenSavingFile'),
      });
    }
  }

  setValue = async (attr, value) => {
    if (attr === 'attachment' && value.files && value.files.length > 0) {
      await this.setState({ attachment: value.files[0] });
    } else if (attr === 'returnedQuantity') {
      const { returnedProducts } = this.state;
      const quantityNumberRegex = /^(0|[1-9]\d*)(\.||,)?(\d+)?$/;

      if (value.value === '0') {
        await this.setState({
          returnedProducts: {
            ...returnedProducts,
            [`${value.code}`]: '0',
          },
        });
      } else if (value.value === '') {
        await this.setState({
          returnedProducts: {
            ...returnedProducts,
            [`${value.code}`]: '0',
          },
        });
      } else if (quantityNumberRegex.test(value.value)) {
        await this.setState({
          returnedProducts: {
            ...returnedProducts,
            [`${value.code}`]: value.value,
          },
        });
      }
    } else if (attr === 'contactEmail') {
      const contactEmailIdList = [];
      if (Object.keys(value).length > 0) {
        for (let index = 0; index < value.length; index += 1) {
          const element = value[index];
          contactEmailIdList.push(element.value);
        }

        await this.setState({ contactEmail: contactEmailIdList });
      }
    } else {
      await this.setState({ [`${attr}`]: value });
    }
  }

  handleEnterKeyPress = async (event) => {
    if (event) event.preventDefault();

    try {
      const { invoiceNumber } = this.state;
      const invoiceDetails = await this.props.getInvoiceDetails(invoiceNumber, this.props.clientId);

      if (invoiceDetails) {
        const returnedProducts = {};
        for (let index = 0; index < invoiceDetails.length; index += 1) {
          const element = invoiceDetails[index];
          returnedProducts[`${element.code}`] = '0';
        }

        await this.setState({
          invoiceDetails,
          returnedProducts,
          invoiceDataReturned: true,
          invoiceError: false,
          invoiceErrorMessage: '',
        });
      } else {
        await this.setState({
          invoiceError: true,
          invoiceErrorMessage: I18n.t('unknownErrorTryingToFindInvoice'),
        });
      }
    } catch (error) {
      if (error.response && error.response.data) {
        if (error.response.data.error && error.response.data.error.code === 1701) {
          await this.setState({
            invoiceError: true,
            invoiceErrorMessage: I18n.t('salesInvoiceNotFound'),
          });
        } else if (error.response.data.error && error.response.data.error.code === 1702) {
          await this.setState({
            invoiceError: true,
            invoiceErrorMessage: I18n.t('invoiceNotRelatedToCustomer'),
          });
        } else if (error.response.data.error && error.response.data.error.code === 1708) {
          await this.setState({
            invoiceError: true,
            invoiceErrorMessage: I18n.t('salesInvoiceOnlyAcceptsNumbers'),
          });
        } else if (error.response.data.error && error.response.data.error.code === 1700) {
          await this.setState({
            invoiceError: true,
            invoiceErrorMessage: I18n.t('salesInvoiceNumberNotFound'),
          });
        } else if (error.response.data.error && error.response.data.error.code === 500) {
          await this.setState({
            invoiceError: true,
            invoiceErrorMessage: I18n.t('clientCodeNotFound'),
          });
        }
      } else {
        await this.setState({
          invoiceError: true,
          invoiceErrorMessage: I18n.t('unknownErrorTryingToFindInvoice'),
        });
      }
    }
  }

  handleFormSubmit = (event) => {
    event.preventDefault();
  }

  render() {
    const {
      invoiceNumber, invoiceDetails, invoiceDataReturned,
      invoiceError, invoiceErrorMessage, returnedProducts,
      reason, description, freight,
      devolutionType, hasDevolutionLetter, attachment,
      error, errorMessage,
      success, successMessage,
    } = this.state;

    const { sphereMotivosList, clientContactEmailsList } = this.props;

    return (
      <main>
        <div className="section section-panel">
          <div className="container">
            <h1 className="panel-title">{I18n.t('devolutionSolicitation')}</h1>
            <div className="panel-content">
              <div className="box-aside box-aside--left">
                <button
                  className="btn cursorPointer"
                  type="button"
                  onClick={() => (history.push(ROUTES.INVOICE_DEVOLUTION_LIST))}
                >
                  {I18n.t('return')}
                </button>
              </div>
              <div className="box-content requests">
                <div className="requests-header request-header-devolution">
                  <span className="request-header-devolution-item">
                    <strong>{I18n.t('newDevolutionSolicitation')}</strong>
                  </span>
                </div>
                <form className="request-devolution-form-invoiceNumber">
                  <label className="description" htmlFor="invoiceNumber">{I18n.t('salesInvoice')}</label>
                  <input
                    id="invoiceNumber"
                    className={invoiceDataReturned ? 'userInput disable' : 'userInput'}
                    type="text"
                    disabled={invoiceDataReturned}
                    required
                    maxLength={43}
                    value={invoiceNumber}
                    onChange={event => this.setValue('invoiceNumber', event.target.value.replace(/[^0-9]/g, ''))}
                    onKeyPress={event => event.key === 'Enter' && this.handleEnterKeyPress(event)}
                  />
                  <div className="buttons">
                    {invoiceDataReturned ? (
                      <button
                        className="erase"
                        type="button"
                        onClick={() => this.setState(this.cleantData())}
                      >
                        <span role="img" aria-label="eraseIcon">❌</span>
                      </button>
                    ) : (
                      <button
                        className="search"
                        type="button"
                        onClick={() => this.handleEnterKeyPress()}
                      >
                        <span role="img" aria-label="searchIcon">🔍</span>
                      </button>
                    )}
                  </div>
                  <div className="errors">
                    {invoiceError ? <p className="errorsWrongMessage">{invoiceErrorMessage}</p> : ''}
                  </div>
                </form>
                {invoiceDataReturned ? (
                  <React.Fragment>
                    <div className="requests-header request-header-devolution">
                      <span className="request-header-devolution-item">
                        <strong>{I18n.t('salesInvoiceProducts')}</strong>
                      </span>
                    </div>
                    <form onSubmit={this.handleFormSubmit} className="request-devolution-form-invoiceProducts">
                      <span>{I18n.t('productCode')}</span>
                      <span>{I18n.t('description')}</span>
                      <span style={{ width: '105px', textAlign: 'center' }}>{I18n.t('qtyToReturn')}</span>
                      <span style={{ textAlign: 'center' }}>{I18n.t('quantityReturned')}</span>
                      <span style={{ textAlign: 'center' }}>{I18n.t('totalQuantity')}</span>
                      {Object.keys(invoiceDetails).map(index => (
                        <React.Fragment key={index}>
                          <span>{invoiceDetails[index].code}</span>
                          <span>{invoiceDetails[index].description}</span>
                          <input
                            className="input-quantity"
                            type="text"
                            disabled={invoiceDetails[index].quantityToBeReturned === 0}
                            value={returnedProducts[`${invoiceDetails[index].code}`] || 0}
                            onChange={event => (this.setValue('returnedQuantity', {
                              code: invoiceDetails[index].code, value: event.target.value,
                            }))}
                          />
                          <span>
                            {invoiceDetails[index].totalQuantity - invoiceDetails[index].quantityToBeReturned}
                          </span>
                          <span>{invoiceDetails[index].totalQuantity}</span>
                        </React.Fragment>
                      ))}
                    </form>
                    <div className="requests-header request-header-devolution">
                      <span className="request-header-devolution-item">
                        <strong>{I18n.t('returnInformation')}</strong>
                      </span>
                    </div>
                    <form className="request-devolution-form-devolutionData">
                      <label className="reason" htmlFor="reason">{I18n.t('reason')}</label>
                      <select
                        className="reasonInput"
                        value={reason}
                        onChange={event => this.setValue('reason', event.target.value)}
                      >
                        <option key={0} value="" />
                        {Object.keys(sphereMotivosList).map(element => (
                          <option key={sphereMotivosList[element].id} value={sphereMotivosList[element].id}>
                            {sphereMotivosList[element].description}
                          </option>
                        ))}
                      </select>
                      <label className="description" htmlFor="descriptionInput">{I18n.t('detailedDescription')}</label>
                      <textarea
                        className="descriptionInput"
                        rows={3}
                        maxLength={500}
                        required
                        value={description}
                        onChange={event => this.setValue('description', event.target.value)}
                      />
                      <label className="freight" htmlFor="freight">{I18n.t('freight')}</label>
                      <select
                        className="freightInput"
                        value={freight}
                        onChange={event => this.setValue('freight', event.target.value)}
                      >
                        <option key={0} value="" />
                        <option key={1} value="CIF">{I18n.t('cifSolicitation')}</option>
                        <option key={2} value="FOB">{I18n.t('fobSolicitation')}</option>
                      </select>
                      <label className="type" htmlFor="devolutionType">{I18n.t('returnType')}</label>
                      <select
                        className="typeInput"
                        value={devolutionType}
                        onChange={event => this.setValue('devolutionType', event.target.value)}
                      >
                        <option key={0} value="" />
                        <option key={2} value={1}>TOTAL</option>
                        <option key={1} value={2}>PARCIAL</option>
                      </select>
                      <label className="devolutionCart" htmlFor="devolutionLetter">{I18n.t('hasReturnLetter')}</label>
                      <select
                        className="devolutionCartInput"
                        value={hasDevolutionLetter}
                        onChange={event => this.setValue('hasDevolutionLetter', event.target.value)}
                      >
                        <option key={0} value="" />
                        <option key={2} value="S">SIM</option>
                        <option key={1} value="N">NÃO</option>
                      </select>
                      <label className="email" htmlFor="contactEmail">{I18n.t('contactEmail')}</label>
                      <Select
                        className="emailInput"
                        styles={customSelectStyles}
                        placeholder={I18n.t('selectClientContacts')}
                        isMulti
                        options={clientContactEmailsList}
                        onChange={event => this.setValue('contactEmail', event)}
                      />
                      <label className="fileAttachment" htmlFor="fileAttachmentInput">{I18n.t('attachment')}</label>
                      <div className="fileAttachmentInput">
                        <input
                          name="image"
                          type="file"
                          multiple={false}
                          accept="image/png, image/jpeg, image/jpg, application/pdf"
                          onChange={event => this.setValue('attachment', event.target)}
                          ref={this.fileInput}
                          style={{ display: 'none' }}
                        />
                        <span style={{ whiteSpace: 'pre' }}>
                          <button
                            type="button"
                            onClick={() => this.fileInput.current.click()}
                          >
                            {I18n.t('uploadFile')}
                          </button>
                          <span style={{ margin: '0 0 0 10px' }}>{attachment ? attachment.name : ''}</span>
                        </span>
                      </div>
                      <button
                        className="btn btn-register button"
                        type="submit"
                        onClick={event => this.handleSubmit(event)}
                      >
                        {I18n.t('openRequest')}
                      </button>
                      <div className="errors">
                        {error ? <p className="errorsWrongMessage">{errorMessage}</p> : ''}
                        {success ? <p className="errosSuccessMessage">{successMessage}</p> : ''}
                      </div>
                    </form>
                  </React.Fragment>
                ) : (
                  <React.Fragment />
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  opico: state.settings.name,
  clientId: state.contracts.selected.client.id,
  sphereMotivosList: state.invoiceDevolution && state.invoiceDevolution.sphereMotivosList,
  clientContactEmailsList: state.invoiceDevolution && state.invoiceDevolution.clientContactEmailsList,
});

const mapDispatchToProps = dispatch => ({
  getInvoiceDetails: (invoiceNumber, clientId) => dispatch(getInvoiceDetails(invoiceNumber, clientId)),
  getSphereNCIMotivosList: devolutionReasonType => dispatch(getSphereMotivosList(devolutionReasonType)),
  getClientContactEmailsList: clientId => dispatch(getClientContactEmailsList(clientId)),
  uploadInvoiceDevolutionFile: (file, name, clientId) => dispatch(uploadInvoiceDevolutionFile(file, name, clientId)),
  sendSolicitation: solicitationData => dispatch(sendInvoiceDevolutionSolicitation(solicitationData)),
  createSolicitation: (solicitationData, sphereId) => dispatch(
    createInvoiceDevolutionSolicitation(solicitationData, sphereId),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDevolutionSolicitationPage);
